import { TableVehicleListDtoToTableVehicleList } from '../../mappers/vehicles';
import { getCurrentGroupId, getManagerId } from '../../utils/functions';
import { api } from './api';
export const VehiclesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getVehiclesTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: '/api/frota/veiculos',
                params: {
                    grupo_Id: getCurrentGroupId(),
                    gestor_id: getManagerId(),
                    data_entrega_cliente: params.startDate,
                    placa: params.plate,
                    chassi: params.chassi,
                    renavam: params.renavam,
                    limit: params.quantity || 5,
                    page: params.page || 1,
                },
            }),
            transformResponse: (response) => TableVehicleListDtoToTableVehicleList(response),
        }),
    }),
});
export const { useLazyGetVehiclesTableDataQuery } = VehiclesApi;
